import moment from "moment";
let timeStemp = moment()
  .add(543, "years")
  .format("DD/MM/YYYY hh:mm:ss", true);
const print_document_a5 = async function (data, AppName) {
  let DATA = data;
  let conpany_name = AppName
  console.log(DATA); 
  console.log(conpany_name); 
  if (DATA.CSI_CAR_N == DATA.CAR_NUMBER) {
    DATA.CSI_CAR_N = "";
  }
  for (const key in DATA) {
    //console.log(DATA[key]);
    if (!DATA[key] || DATA[key] == undefined) {
      DATA[key] = "-";
    }
    //console.log(DATA[key]);
  } 
  let newCar_typew = "*",
    newWA = 0,
    newWB = 0,
    newWC = 0;

  DATA.CAR_TYPE = "1" ?
    (newCar_typew = "4 ล้อ") :
    (DATA.CAR_TYPE = "2" ? newCar_typew == "6 ล้อ" : (newCar_typew = "-"));
  let newTimeDATAW_I = await newTime(DATA.W_I);
  let newTimeDATAW_O = await newTime(DATA.W_O);
  let newTimeDATAD_D = await newTimeN(
    DATA.D_D != "" || DATA.D_D != undefined ? DATA.D_D : "-"
  );
  DATA.W_O = newTimeDATAW_O.b;
  DATA.W_I = newTimeDATAW_I.b;
  DATA.D_D = newTimeDATAD_D;

  const pdf = {
    pageSize: "A5",
    pageOrientation: "landscape",
    // pageMargins: [ 30, 0, 30, 0 ],
    //สีพื้นหลัง
    background: function (currentPage) {
      // console.log(currentPage == 1)
      if (currentPage == 1) {
        return {
          canvas: [{
            type: "rect",
            x: 0,
            y: 0,
            w: 594.9,
            h: 419,
            color: "#D8F1F1",
          }, ],
        };
      } else if (currentPage == 2) {
        // return {
        //   canvas: [
        //     {
        //       type: "rect",
        //       x: 0,
        //       y:0,
        //       w: 594.9,
        //       h: 419,
        //       color: "#00BFFF",
        //     },
        //   ],
        // };
      } else if (currentPage == 3) {
        return {
          canvas: [{
            type: "rect",
            x: 0,
            y: 0,
            w: 594.9,
            h: 419,
            color: "#FAFCD9",
          }, ],
        };
      } else if (currentPage == 4) {
        return {
          canvas: [{
            type: "rect",
            x: 0,
            y: 0,
            w: 594.9,
            h: 419,
            color: "#FCDEE2",
          }, ],
        };
      } else if (currentPage == 5) {
        // return {
        //   canvas: [
        //     {
        //       type: "rect",
        //       x: 0,
        //       y:0,
        //       w: 594.9,
        //       h: 419,
        //       color: "#00BFFF",
        //     },
        //   ],
        // };
      } else if (currentPage == 6) {
        // return {
        //   canvas: [
        //     {
        //       type: "rect",
        //       x: 0,
        //       y:0,
        //       w: 594.9,
        //       h: 419,
        //       color: "#00BFFF",
        //     },
        //   ],
        // };
      }
    },
    // background: function(currentPage) {

    //   return `page ${currentPage} `
    // },

    content: [
      // ตช.01/1
      {
        columns: [{
            text: ``,
            width: 500,
            alignment: "center",
            // margin: [0, 0, 0, 0],//left top right bottom
          },
          {
            text: `ตช.01/1 `,
            width: 30,
            alignment: "right",
            // margin: [0, 0, 0, 10],//left top right bottom
            padding: [0, 0, 0, 10],
          },
        ],
      },
      {
        columns: [{
            text: `เลขที่ :   ${DATA.T_ID} \nวันที่พิมพ์    ${timeStemp} น. `,

            alignment: "left",
            // margin: [0, 0, 0, 0],//left top right bottom
          },
          {
            image: await getBase64ImageFromURL(
              conpany_name.LogoPath
            ),
            width: 60,
            // margin: [1, 15, 0, 0],
            alignment: "center",
          },
          {
            qr: DATA.rootURL,
            fit: 60,
            alignment: "right",
            margin: [0, 0, 0, 0], //left top right bottom
          },
        ],
      },
      {
        columns: [{
          text: `เอกสารกำกับขนส่งมูลฝอยติดเชื้อ ตช.01/1 ต้นฉบับสำหรับโรงพยาบาล`,

          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 0],
        }, ],
        columnGap: 200,
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 80,
            text: `ชื่อเอกชน/ผู้เก็บขน ที่อยู่`,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: 500,
            text: "" + conpany_name.CoLtdMenuBarFull + " 389/40 หมู่ 2 ต.สันผีเสื้อ อ.เมือง จ.เชียงใหม่ 50300 เลขผู้เสียภาษีอากร 0505563001372 โทร 081-6949845",
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 80,
            text: `ลักษณะพาหนะที่ใช้`,
          },
          {
            table: {
              headerRows: 1,
              widths: [5],
              bodyRows: 2,
              body: [
                [{
                  text: " ",
                  fontSize: 5,
                }, ],
              ],
            },
            width: 19,
          },
          {
            // auto-sized columns have their widths based on their content
            width: 180,
            text: `1.ปรับอุณหภูมิ 10 ํC หรือต่ำกว่าได้`,
          },
          {
            table: {
              headerRows: 1,
              widths: [5],
              bodyRows: 2,
              body: [
                [{
                  text: " ",
                  fontSize: 5,
                }, ],
              ],
            },
            width: 19,
          },
          {
            // auto-sized columns have their widths based on their content
            text: `2. อื่นๆ ระบุ ....................................`,
          },
        ],
        // optional space between columns
      },

      {
        //ชื่อคนขับรถ
        columns: [{
            text: `เลขทะเบียนเก็บขนขยะ ${DATA.CAR_NUMBER} `,
            width: 130,
          },
          {
            text: ` ชื่อคนขับรถ ${DATA.PD_NAME} ${DATA.PD_LAST} `,
          },
          {
            text: ` ชื่อพนักงานเก็บขน ${DATA.PC_NAME} ${DATA.PC_LAST} `,
          },
          {
            text: ` เลขทะเบียนรถเปลี่ยนถ่าย .${DATA.CSI_CAR_N} `,
            width: 180,
          },
        ],
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 90,
            text: `คำรับรองของผู้ก่อนกำเนิด:`,

            bold: true,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: 500,
            text: "ข้าพเจ้าขอรับรองว่าได้ส่งมอบมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ คัดแยกประเภท บรรจุ ติดป้าย และฉลากอย่างเหมาะสมตามข้อกำหนดกฏหมาย",
          },
        ],
        // optional space between columns
      },
      {
        table: {
          headerRows: 1,
          widths: [45, 140, 40, 40, 60, 100, 40],
          bodyRows: 2,
          body: [
            [{
                text: "วันที่",
                bold: true,

                alignment: "center",
              },
              {
                text: "แหล่งกำเนิดมูลฝอยติดเชื้อ",
                bold: true,

                alignment: "center",
              },
              {
                text: "เวลาเข้าเก็บ",

                bold: true,
                alignment: "center",
              },
              {
                text: "เวลาออก",

                bold: true,
                alignment: "center",
              },
              {
                text: "ปริมาณมูลฝอย",

                bold: true,
                alignment: "center",
              },
              {
                text: "ขื่อ จนท.รพ",

                bold: true,
                alignment: "center",
              },
              {
                text: "ลายเซ็น",

                bold: true,
                alignment: "center",
              },
            ],
            [{
                text: `${newTimeDATAW_I.a}`,

                alignment: "center",
                justify: "center",
              },
              {
                text: DATA.C_N + " " + DATA.C_A,

                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_I} น.`,

                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_O} น.`,

                alignment: "center",
                justify: "center",
              },
              {
                text: DATA.W_W + " กก.",

                alignment: "center",
                justify: "center",
              },
              {
                text: ``, //DATA.P_N

                alignment: "center",
                justify: "center",
              },
              {
                image: await getBase64ImageFromURL(DATA.urlO),
                width: 35,
                height: 25,

                alignment: "center",
              },
            ],
          ],
        },
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 100,
            text: `คำรับรองของผู้ขนส่ง: `,

            bold: true,
            margin: [0, 3, 0, 0],
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: "*",
            text: "ข้าพเจ้าขอรับรองว่าได้รับมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ และได้ขนส่งไปตามข้อกำหนดของกฏหมาย",

            margin: [0, 3, 0, 0],
          },
        ],
        // optional space between columns
      },
      {
        //.................................................

        columns: [{
            text: `ชื่อตัวบรรจง   .................................................................................`,
            width: 205,
          },
          {
            text: `ลายเซ็น   .....................................`,
            width: 105,
          },
          {
            image: await getBase64ImageFromURL(
              conpany_name.SignaturePath
            ),
            width: 35,
            height: 20,
            margin: [0, 0, 0, 0],
          },
          {
            text: `......................................`,
            width: 165,
          },
        ],
      },
      {
        text: `________________________________________________________________________________________________________________________`,
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 50,
            text: `สถานที่กำจัด `,

            bold: true,
          },
          {
            // auto-sized columns have their widths based on their content

            text: `บริษัทโชติฐกรณ์พิบูล จำกัด ที่อยู่ 15/5 หมู่1 ต.หนองกรด อ.เมือง จ.นครสวรรค์ 60240 โทรศัพท์  090-9409932,086-4466295`,
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 100,
            text: `คำรับรองของผู้กำจัด: `,

            bold: true,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: "*",
            text: "ข้าพเจ้าขอรับรองว่าได้รับมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ ",
          },
          {
            text: `ปริมาณสุทธิ ...........  กิโลกรัม`,
            width: 100,
            alignment: "center",
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            text: `ชื่อตัวบรรจง     ..............................................................................`,
            width: 205,
          },
          {
            text: `ลายเซ็น ...................`,
            width: 75,
          },
          // {
          //   image: await getBase64ImageFromURL(DATA.urlR),
          //   width: 35,
          //   height: 20,
          //   alignment: "start",
          // },
          {
            text: `........`,
            width: 25,
          },
          {
            text: `  ว.ด.ป ..........................ที่รับมอบ`,
            margin: [0, 0, 0, 0],
            pageBreak: "after",
          },
        ],
      },

      // ตช.01/2
      {
        columns: [{
            text: ``,
            width: 500,
            alignment: "center",
            // margin: [0, 0, 0, 0],//left top right bottom
          },
          {
            text: `ตช.01/2 `,
            width: 30,
            alignment: "right",
            // margin: [0, 0, 0, 10],//left top right bottom
            padding: [0, 0, 0, 10],
          },
        ],
      },
      {
        columns: [{
            text: `เลขที่ :   ${DATA.T_ID} \nวันที่พิมพ์    ${timeStemp} น. `,

            alignment: "left",
            // margin: [0, 0, 0, 0],//left top right bottom
          },
          {
            image: await getBase64ImageFromURL(
              conpany_name.LogoPath
            ),
            width: 60,
            // margin: [1, 15, 0, 0],
            alignment: "center",
          },
          {
            qr: DATA.rootURL,
            fit: 60,
            alignment: "right",
            margin: [0, 0, 0, 0], //left top right bottom
          },
        ],
      },
      {
        columns: [{
          text: `เอกสารกำกับขนส่งมูลฝอยติดเชื้อ ตช.01/2 สำเนาส่งกลับโรงพยาบาล`,

          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 0],
        }, ],
        columnGap: 200,
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 80,
            text: `ชื่อเอกชน/ผู้เก็บขน ที่อยู่`,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: 500,
            text: "" + conpany_name.CoLtdMenuBarFull + " 389/40 หมู่ 2 ต.สันผีเสื้อ อ.เมือง จ.เชียงใหม่ 50300 เลขผู้เสียภาษีอากร 0505563001372 โทร 081-6949845",
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 80,
            text: `ลักษณะพาหนะที่ใช้`,
          },
          {
            table: {
              headerRows: 1,
              widths: [5],
              bodyRows: 2,
              body: [
                [{
                  text: " ",
                  fontSize: 5,
                }, ],
              ],
            },
            width: 19,
          },
          {
            // auto-sized columns have their widths based on their content
            width: 180,
            text: `1.ปรับอุณหภูมิ 10 ํC หรือต่ำกว่าได้`,
          },
          {
            table: {
              headerRows: 1,
              widths: [5],
              bodyRows: 2,
              body: [
                [{
                  text: " ",
                  fontSize: 5,
                }, ],
              ],
            },
            width: 19,
          },
          {
            // auto-sized columns have their widths based on their content
            text: `2. อื่นๆ ระบุ ....................................`,
          },
        ],
        // optional space between columns
      },
      {
        //ชื่อคนขับรถ
        columns: [{
            text: `เลขทะเบียนเก็บขนขยะ ${DATA.CAR_NUMBER} `,
            width: 130,
          },
          {
            text: ` ชื่อคนขับรถ ${DATA.PD_NAME} ${DATA.PD_LAST} `,
          },
          {
            text: ` ชื่อพนักงานเก็บขน ${DATA.PC_NAME} ${DATA.PC_LAST} `,
          },
          {
            text: ` เลขทะเบียนรถเปลี่ยนถ่าย .${DATA.CSI_CAR_N} `,
            width: 180,
          },
        ],
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 90,
            text: `คำรับรองของผู้ก่อนกำเนิด:`,

            bold: true,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: 500,
            text: "ข้าพเจ้าขอรับรองว่าได้ส่งมอบมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ คัดแยกประเภท บรรจุ ติดป้าย และฉลากอย่างเหมาะสมตามข้อกำหนดกฏหมาย",
          },
        ],
        // optional space between columns
      },
      {
        table: {
          headerRows: 1,
          widths: [45, 140, 40, 40, 60, 100, 40],
          bodyRows: 2,
          body: [
            [{
                text: "วันที่",
                bold: true,

                alignment: "center",
              },
              {
                text: "แหล่งกำเนิดมูลฝอยติดเชื้อ",
                bold: true,

                alignment: "center",
              },
              {
                text: "เวลาเข้าเก็บ",

                bold: true,
                alignment: "center",
              },
              {
                text: "เวลาออก",

                bold: true,
                alignment: "center",
              },
              {
                text: "ปริมาณมูลฝอย",

                bold: true,
                alignment: "center",
              },
              {
                text: "ขื่อ จนท.รพ",

                bold: true,
                alignment: "center",
              },
              {
                text: "ลายเซ็น",

                bold: true,
                alignment: "center",
              },
            ],
            [{
                text: `${newTimeDATAW_I.a}`,

                alignment: "center",
                justify: "center",
              },
              {
                text: DATA.C_N + " " + DATA.C_A,

                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_I} น.`,

                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_O} น.`,

                alignment: "center",
                justify: "center",
              },
              {
                text: DATA.W_W + " กก.",

                alignment: "center",
                justify: "center",
              },
              {
                text: ``, //DATA.P_N

                alignment: "center",
                justify: "center",
              },
              {
                image: await getBase64ImageFromURL(DATA.urlO),
                width: 35,
                height: 25,

                alignment: "center",
              },
            ],
          ],
        },
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 100,
            text: `คำรับรองของผู้ขนส่ง: `,

            bold: true,
            margin: [0, 3, 0, 0],
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: "*",
            text: "ข้าพเจ้าขอรับรองว่าได้รับมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ และได้ขนส่งไปตามข้อกำหนดของกฏหมาย",

            margin: [0, 3, 0, 0],
          },
        ],
        // optional space between columns
      },
      {
        //.................................................

        columns: [{
            text: `ชื่อตัวบรรจง   .................................................................................`,
            width: 205,
          },
          {
            text: `ลายเซ็น   .....................................`,
            width: 105,
          },
          {
            image: await getBase64ImageFromURL(
              conpany_name.SignaturePath
            ),
            width: 35,
            height: 20,
            margin: [0, 0, 0, 0],
          },
          {
            text: `......................................`,
            width: 165,
          },
        ],
      },
      {
        text: `________________________________________________________________________________________________________________________`,
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 50,
            text: `สถานที่กำจัด `,

            bold: true,
          },
          {
            // auto-sized columns have their widths based on their content

            text: `บริษัทโชติฐกรณ์พิบูล จำกัด ที่อยู่ 15/5 หมู่1 ต.หนองกรด อ.เมือง จ.นครสวรรค์ 60240 โทรศัพท์  090-9409932,086-4466295`,
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 100,
            text: `คำรับรองของผู้กำจัด: `,

            bold: true,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: "*",
            text: "ข้าพเจ้าขอรับรองว่าได้รับมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ ",
          },
          {
            text: `ปริมาณสุทธิ  ${DATA.W_W}  กิโลกรัม`,
            width: 100,
            alignment: "center",
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            text: `ชื่อตัวบรรจง     ..............................................................................`,
            width: 205,
          },
          {
            text: `ลายเซ็น ...`,
            width: 35,
          },
          {
            image: await getBase64ImageFromURL(DATA.urlR),
            width: 35,
            height: 20,
            alignment: "start",
          },
          {
            text: `.......`,
            width: 25,
          },
          {
            text: `  ว.ด.ป .....${DATA.D_D} น. .....................ที่รับมอบ`,
            margin: [0, 0, 0, 0],
            pageBreak: "after",
          },

        ],
      },

      // ตช.2
      {
        columns: [{
            text: ``,
            width: 500,
            alignment: "center",
            // margin: [0, 0, 0, 0],//left top right bottom
          },
          {
            text: `ตช.2 `,
            width: 30,
            alignment: "right",
            // margin: [0, 0, 0, 10],//left top right bottom
            padding: [0, 0, 0, 10],
          },
        ],
      },
      {
        columns: [{
            text: `เลขที่ :   ${DATA.T_ID} \nวันที่พิมพ์    ${timeStemp} น. `,

            alignment: "left",
            // margin: [0, 0, 0, 0],//left top right bottom
          },
          {
            image: await getBase64ImageFromURL(
              conpany_name.LogoPath
            ),
            width: 60,
            // margin: [1, 15, 0, 0],
            alignment: "center",
          },
          {
            qr: DATA.rootURL,
            fit: 60,
            alignment: "right",
            margin: [0, 0, 0, 0], //left top right bottom
          },
        ],
      },
      {
        columns: [{
          text: `เอกสารกำกับขนส่งมูลฝอยติดเชื้อ ตช.2 สำหรับผู้กำจัดมูลฝอยติดเชื้อเก็บเป็นหลักฐาน`,

          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 0],
        }, ],
        columnGap: 200,
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 80,
            text: `ชื่อเอกชน/ผู้เก็บขน ที่อยู่`,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: 500,
            text: "" + conpany_name.CoLtdMenuBarFull + " 389/40 หมู่ 2 ต.สันผีเสื้อ อ.เมือง จ.เชียงใหม่ 50300 เลขผู้เสียภาษีอากร 0505563001372 โทร 081-6949845",
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 80,
            text: `ลักษณะพาหนะที่ใช้`,
          },
          {
            table: {
              headerRows: 1,
              widths: [5],
              bodyRows: 2,
              body: [
                [{
                  text: " ",
                  fontSize: 5,
                }, ],
              ],
            },
            width: 19,
          },
          {
            // auto-sized columns have their widths based on their content
            width: 180,
            text: `1.ปรับอุณหภูมิ 10 ํC หรือต่ำกว่าได้`,
          },
          {
            table: {
              headerRows: 1,
              widths: [5],
              bodyRows: 2,
              body: [
                [{
                  text: " ",
                  fontSize: 5,
                }, ],
              ],
            },
            width: 19,
          },
          {
            // auto-sized columns have their widths based on their content
            text: `2. อื่นๆ ระบุ ....................................`,
          },
        ],
        // optional space between columns
      },
      {
        //ชื่อคนขับรถ
        columns: [{
            text: `เลขทะเบียนเก็บขนขยะ ${DATA.CAR_NUMBER} `,
            width: 130,
          },
          {
            text: ` ชื่อคนขับรถ ${DATA.PD_NAME} ${DATA.PD_LAST} `,
          },
          {
            text: ` ชื่อพนักงานเก็บขน ${DATA.PC_NAME} ${DATA.PC_LAST} `,
          },
          {
            text: ` เลขทะเบียนรถเปลี่ยนถ่าย .${DATA.CSI_CAR_N} `,
            width: 180,
          },
        ],
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 90,
            text: `คำรับรองของผู้ก่อนกำเนิด:`,

            bold: true,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: 500,
            text: "ข้าพเจ้าขอรับรองว่าได้ส่งมอบมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ คัดแยกประเภท บรรจุ ติดป้าย และฉลากอย่างเหมาะสมตามข้อกำหนดกฏหมาย",
          },
        ],
        // optional space between columns
      },
      {
        table: {
          headerRows: 1,
          widths: [45, 140, 40, 40, 60, 100, 40],
          bodyRows: 2,
          body: [
            [{
                text: "วันที่",
                bold: true,

                alignment: "center",
              },
              {
                text: "แหล่งกำเนิดมูลฝอยติดเชื้อ",
                bold: true,

                alignment: "center",
              },
              {
                text: "เวลาเข้าเก็บ",

                bold: true,
                alignment: "center",
              },
              {
                text: "เวลาออก",

                bold: true,
                alignment: "center",
              },
              {
                text: "ปริมาณมูลฝอย",

                bold: true,
                alignment: "center",
              },
              {
                text: "ขื่อ จนท.รพ",

                bold: true,
                alignment: "center",
              },
              {
                text: "ลายเซ็น",

                bold: true,
                alignment: "center",
              },
            ],
            [{
                text: `${newTimeDATAW_I.a}`,

                alignment: "center",
                justify: "center",
              },
              {
                text: DATA.C_N + " " + DATA.C_A,

                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_I} น.`,

                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_O} น.`,

                alignment: "center",
                justify: "center",
              },
              {
                text: DATA.W_W + " กก.",

                alignment: "center",
                justify: "center",
              },
              {
                text: ``, //DATA.P_N

                alignment: "center",
                justify: "center",
              },
              {
                image: await getBase64ImageFromURL(DATA.urlO),
                width: 35,
                height: 25,

                alignment: "center",
              },
            ],
          ],
        },
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 100,
            text: `คำรับรองของผู้ขนส่ง: `,

            bold: true,
            margin: [0, 3, 0, 0],
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: "*",
            text: "ข้าพเจ้าขอรับรองว่าได้รับมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ และได้ขนส่งไปตามข้อกำหนดของกฏหมาย",

            margin: [0, 3, 0, 0],
          },
        ],
        // optional space between columns
      },
      {
        //.................................................

        columns: [{
            text: `ชื่อตัวบรรจง   .................................................................................`,
            width: 205,
          },
          {
            text: `ลายเซ็น   .....................................`,
            width: 105,
          },
          {
            image: await getBase64ImageFromURL(
              conpany_name.SignaturePath
            ),
            width: 35,
            height: 20,
            margin: [0, 0, 0, 0],
          },
          {
            text: `......................................`,
            width: 165,
          },
        ],
      },
      {
        text: `________________________________________________________________________________________________________________________`,
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 50,
            text: `สถานที่กำจัด `,

            bold: true,
          },
          {
            // auto-sized columns have their widths based on their content

            text: `บริษัทโชติฐกรณ์พิบูล จำกัด ที่อยู่ 15/5 หมู่1 ต.หนองกรด อ.เมือง จ.นครสวรรค์ 60240 โทรศัพท์  090-9409932,086-4466295`,
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 100,
            text: `คำรับรองของผู้กำจัด: `,

            bold: true,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: "*",
            text: "ข้าพเจ้าขอรับรองว่าได้รับมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ ",
          },
          {
            text: `ปริมาณสุทธิ  ${DATA.W_W}  กิโลกรัม`,
            width: 100,
            alignment: "center",
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            text: `ชื่อตัวบรรจง     ..............................................................................`,
            width: 205,
          },
          {
            text: `ลายเซ็น ....`,
            width: 35,
          },
          {
            image: await getBase64ImageFromURL(DATA.urlR),
            width: 35,
            height: 20,
            alignment: "start",
          },
          {
            text: `.........`,
            width: 25,
          },
          {
            text: `  ว.ด.ป .....${DATA.D_D} น. .....................ที่รับมอบ`,
            margin: [0, 0, 0, 0],
            pageBreak: "after",
          },

        ],
      },

      // ตช.3
      {
        columns: [{
            text: ``,
            width: 500,
            alignment: "center",
            // margin: [0, 0, 0, 0],//left top right bottom
          },
          {
            text: `ตช.3 `,
            width: 30,
            alignment: "right",
            // margin: [0, 0, 0, 10],//left top right bottom
            padding: [0, 0, 0, 10],
          },
        ],
      },
      {
        columns: [{
            text: `เลขที่ :   ${DATA.T_ID} \nวันที่พิมพ์    ${timeStemp} น. `,

            alignment: "left",
            // margin: [0, 0, 0, 0],//left top right bottom
          },
          {
            image: await getBase64ImageFromURL(
              conpany_name.LogoPath
            ),
            width: 60,
            // margin: [1, 15, 0, 0],
            alignment: "center",
          },
          {
            qr: DATA.rootURL,
            fit: 60,
            alignment: "right",
            margin: [0, 0, 0, 0], //left top right bottom
          },
        ],
      },
      {
        columns: [{
          text: `เอกสารกำกับขนส่งมูลฝอยติดเชื้อ ตช.3 สำหรับผู้ส่งมูลฝอยติดเชื้อเก็บเป็นหลักฐาน`,

          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 0],
        }, ],
        columnGap: 200,
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 80,
            text: `ชื่อเอกชน/ผู้เก็บขน ที่อยู่`,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: 500,
            text: "" + conpany_name.CoLtdMenuBarFull + " 389/40 หมู่ 2 ต.สันผีเสื้อ อ.เมือง จ.เชียงใหม่ 50300 เลขผู้เสียภาษีอากร 0505563001372 โทร 081-6949845",
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 80,
            text: `ลักษณะพาหนะที่ใช้`,
          },
          {
            table: {
              headerRows: 1,
              widths: [5],
              bodyRows: 2,
              body: [
                [{
                  text: " ",
                  fontSize: 5,
                }, ],
              ],
            },
            width: 19,
          },
          {
            // auto-sized columns have their widths based on their content
            width: 180,
            text: `1.ปรับอุณหภูมิ 10 ํC หรือต่ำกว่าได้`,
          },
          {
            table: {
              headerRows: 1,
              widths: [5],
              bodyRows: 2,
              body: [
                [{
                  text: " ",
                  fontSize: 5,
                }, ],
              ],
            },
            width: 19,
          },
          {
            // auto-sized columns have their widths based on their content
            text: `2. อื่นๆ ระบุ ....................................`,
          },
        ],
        // optional space between columns
      },
      {
        //ชื่อคนขับรถ
        columns: [{
            text: `เลขทะเบียนเก็บขนขยะ ${DATA.CAR_NUMBER} `,
            width: 130,
          },
          {
            text: ` ชื่อคนขับรถ ${DATA.PD_NAME} ${DATA.PD_LAST} `,
          },
          {
            text: ` ชื่อพนักงานเก็บขน ${DATA.PC_NAME} ${DATA.PC_LAST} `,
          },
          {
            text: ` เลขทะเบียนรถเปลี่ยนถ่าย .${DATA.CSI_CAR_N} `,
            width: 180,
          },
        ],
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 90,
            text: `คำรับรองของผู้ก่อนกำเนิด:`,

            bold: true,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: 500,
            text: "ข้าพเจ้าขอรับรองว่าได้ส่งมอบมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ คัดแยกประเภท บรรจุ ติดป้าย และฉลากอย่างเหมาะสมตามข้อกำหนดกฏหมาย",
          },
        ],
        // optional space between columns
      },
      {
        table: {
          headerRows: 1,
          widths: [45, 140, 40, 40, 60, 100, 40],
          bodyRows: 2,
          body: [
            [{
                text: "วันที่",
                bold: true,

                alignment: "center",
              },
              {
                text: "แหล่งกำเนิดมูลฝอยติดเชื้อ",
                bold: true,

                alignment: "center",
              },
              {
                text: "เวลาเข้าเก็บ",

                bold: true,
                alignment: "center",
              },
              {
                text: "เวลาออก",

                bold: true,
                alignment: "center",
              },
              {
                text: "ปริมาณมูลฝอย",

                bold: true,
                alignment: "center",
              },
              {
                text: "ขื่อ จนท.รพ",

                bold: true,
                alignment: "center",
              },
              {
                text: "ลายเซ็น",

                bold: true,
                alignment: "center",
              },
            ],
            [{
                text: `${newTimeDATAW_I.a}`,

                alignment: "center",
                justify: "center",
              },
              {
                text: DATA.C_N + " " + DATA.C_A,

                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_I} น.`,

                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_O} น.`,

                alignment: "center",
                justify: "center",
              },
              {
                text: DATA.W_W + " กก.",

                alignment: "center",
                justify: "center",
              },
              {
                text: ``, //DATA.P_N

                alignment: "center",
                justify: "center",
              },
              {
                image: await getBase64ImageFromURL(DATA.urlO),
                width: 35,
                height: 25,

                alignment: "center",
              },
            ],
          ],
        },
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 100,
            text: `คำรับรองของผู้ขนส่ง: `,

            bold: true,
            margin: [0, 3, 0, 0],
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: "*",
            text: "ข้าพเจ้าขอรับรองว่าได้รับมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ และได้ขนส่งไปตามข้อกำหนดของกฏหมาย",

            margin: [0, 3, 0, 0],
          },
        ],
        // optional space between columns
      },
      {
        //.................................................

        columns: [{
            text: `ชื่อตัวบรรจง   .................................................................................`,
            width: 205,
          },
          {
            text: `ลายเซ็น   .....................................`,
            width: 105,
          },
          {
            image: await getBase64ImageFromURL(
              conpany_name.SignaturePath
            ),
            width: 35,
            height: 20,
            margin: [0, 0, 0, 0],
          },
          {
            text: `......................................`,
            width: 165,
          },
        ],
      },
      {
        text: `________________________________________________________________________________________________________________________`,
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 50,
            text: `สถานที่กำจัด `,

            bold: true,
          },
          {
            // auto-sized columns have their widths based on their content

            text: `บริษัทโชติฐกรณ์พิบูล จำกัด ที่อยู่ 15/5 หมู่1 ต.หนองกรด อ.เมือง จ.นครสวรรค์ 60240 โทรศัพท์  090-9409932,086-4466295`,
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 100,
            text: `คำรับรองของผู้กำจัด: `,

            bold: true,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: "*",
            text: "ข้าพเจ้าขอรับรองว่าได้รับมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ ",
          },
          {
            text: `ปริมาณสุทธิ  ${DATA.W_W}  กิโลกรัม`,
            width: 100,
            alignment: "center",
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            text: `ชื่อตัวบรรจง     ..............................................................................`,
            width: 205,
          },
          {
            text: `ลายเซ็น ....`,
            width: 35,
          },
          {
            image: await getBase64ImageFromURL(DATA.urlR),
            width: 35,
            height: 20,
            alignment: "start",
          },
          {
            text: `........`,
            width: 25,
          },
          {
            text: `  ว.ด.ป .....${DATA.D_D} น. .....................ที่รับมอบ`,
            margin: [0, 0, 0, 0],
            pageBreak: "after",
          },

        ],
      },

      // ตช.4
      {
        columns: [{
            text: ``,
            width: 500,
            alignment: "center",
            // margin: [0, 0, 0, 0],//left top right bottom
          },
          {
            text: `ตช.4 `,
            width: 30,
            alignment: "right",
            // margin: [0, 0, 0, 10],//left top right bottom
            padding: [0, 0, 0, 10],
          },
        ],
      },
      {
        columns: [{
            text: `เลขที่ :   ${DATA.T_ID} \nวันที่พิมพ์    ${timeStemp} น. `,

            alignment: "left",
            // margin: [0, 0, 0, 0],//left top right bottom
          },
          {
            image: await getBase64ImageFromURL(
              conpany_name.LogoPath
            ),
            width: 60,
            // margin: [1, 15, 0, 0],
            alignment: "center",
          },
          {
            qr: DATA.rootURL,
            fit: 60,
            alignment: "right",
            margin: [0, 0, 0, 0], //left top right bottom
          },
        ],
      },
      {
        columns: [{
          text: `เอกสารกำกับขนส่งมูลฝอยติดเชื้อ ตช.4 ส่งองด์กรปกครองส่วนท้องถิ่นที่โรงพยาบาลตั้งอยู่`,

          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 0],
        }, ],
        columnGap: 200,
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 80,
            text: `ชื่อเอกชน/ผู้เก็บขน ที่อยู่`,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: 500,
            text: "" + conpany_name.CoLtdMenuBarFull + " 389/40 หมู่ 2 ต.สันผีเสื้อ อ.เมือง จ.เชียงใหม่ 50300 เลขผู้เสียภาษีอากร 0505563001372 โทร 081-6949845",
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 80,
            text: `ลักษณะพาหนะที่ใช้`,
          },
          {
            table: {
              headerRows: 1,
              widths: [5],
              bodyRows: 2,
              body: [
                [{
                  text: " ",
                  fontSize: 5,
                }, ],
              ],
            },
            width: 19,
          },
          {
            // auto-sized columns have their widths based on their content
            width: 180,
            text: `1.ปรับอุณหภูมิ 10 ํC หรือต่ำกว่าได้`,
          },
          {
            table: {
              headerRows: 1,
              widths: [5],
              bodyRows: 2,
              body: [
                [{
                  text: " ",
                  fontSize: 5,
                }, ],
              ],
            },
            width: 19,
          },
          {
            // auto-sized columns have their widths based on their content
            text: `2. อื่นๆ ระบุ ....................................`,
          },
        ],
        // optional space between columns
      },
      {
        //ชื่อคนขับรถ
        columns: [{
            text: `เลขทะเบียนเก็บขนขยะ ${DATA.CAR_NUMBER} `,
            width: 130,
          },
          {
            text: ` ชื่อคนขับรถ ${DATA.PD_NAME} ${DATA.PD_LAST} `,
          },
          {
            text: ` ชื่อพนักงานเก็บขน ${DATA.PC_NAME} ${DATA.PC_LAST} `,
          },
          {
            text: ` เลขทะเบียนรถเปลี่ยนถ่าย .${DATA.CSI_CAR_N} `,
            width: 180,
          },
        ],
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 90,
            text: `คำรับรองของผู้ก่อนกำเนิด:`,

            bold: true,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: 500,
            text: "ข้าพเจ้าขอรับรองว่าได้ส่งมอบมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ คัดแยกประเภท บรรจุ ติดป้าย และฉลากอย่างเหมาะสมตามข้อกำหนดกฏหมาย",
          },
        ],
        // optional space between columns
      },
      {
        table: {
          headerRows: 1,
          widths: [45, 140, 40, 40, 60, 100, 40],
          bodyRows: 2,
          body: [
            [{
                text: "วันที่",
                bold: true,

                alignment: "center",
              },
              {
                text: "แหล่งกำเนิดมูลฝอยติดเชื้อ",
                bold: true,

                alignment: "center",
              },
              {
                text: "เวลาเข้าเก็บ",

                bold: true,
                alignment: "center",
              },
              {
                text: "เวลาออก",

                bold: true,
                alignment: "center",
              },
              {
                text: "ปริมาณมูลฝอย",

                bold: true,
                alignment: "center",
              },
              {
                text: "ขื่อ จนท.รพ",

                bold: true,
                alignment: "center",
              },
              {
                text: "ลายเซ็น",

                bold: true,
                alignment: "center",
              },
            ],
            [{
                text: `${newTimeDATAW_I.a}`,

                alignment: "center",
                justify: "center",
              },
              {
                text: DATA.C_N + " " + DATA.C_A,

                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_I} น.`,

                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_O} น.`,

                alignment: "center",
                justify: "center",
              },
              {
                text: DATA.W_W + " กก.",

                alignment: "center",
                justify: "center",
              },
              {
                text: ``, //DATA.P_N

                alignment: "center",
                justify: "center",
              },
              {
                image: await getBase64ImageFromURL(DATA.urlO),
                width: 35,
                height: 25,

                alignment: "center",
              },
            ],
          ],
        },
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 100,
            text: `คำรับรองของผู้ขนส่ง: `,

            bold: true,
            margin: [0, 3, 0, 0],
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: "*",
            text: "ข้าพเจ้าขอรับรองว่าได้รับมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ และได้ขนส่งไปตามข้อกำหนดของกฏหมาย",

            margin: [0, 3, 0, 0],
          },
        ],
        // optional space between columns
      },
      {
        //.................................................

        columns: [{
            text: `ชื่อตัวบรรจง   .................................................................................`,
            width: 205,
          },
          {
            text: `ลายเซ็น   .....................................`,
            width: 105,
          },
          {
            image: await getBase64ImageFromURL(
              conpany_name.SignaturePath
            ),
            width: 35,
            height: 20,
            margin: [0, 0, 0, 0],
          },
          {
            text: `......................................`,
            width: 165,
          },
        ],
      },
      {
        text: `________________________________________________________________________________________________________________________`,
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 50,
            text: `สถานที่กำจัด `,

            bold: true,
          },
          {
            // auto-sized columns have their widths based on their content

            text: `บริษัทโชติฐกรณ์พิบูล จำกัด ที่อยู่ 15/5 หมู่1 ต.หนองกรด อ.เมือง จ.นครสวรรค์ 60240 โทรศัพท์  090-9409932,086-4466295`,
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 100,
            text: `คำรับรองของผู้กำจัด: `,

            bold: true,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: "*",
            text: "ข้าพเจ้าขอรับรองว่าได้รับมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ ",
          },
          {
            text: `ปริมาณสุทธิ  ${DATA.W_W}  กิโลกรัม`,
            width: 100,
            alignment: "center",
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            text: `ชื่อตัวบรรจง     ..............................................................................`,
            width: 205,
          },
          {
            text: `ลายเซ็น ....`,
            width: 35,
          },
          {
            image: await getBase64ImageFromURL(DATA.urlR),
            width: 35,
            height: 20,
            alignment: "start",
          },
          {
            text: `........`,
            width: 25,
          },
          {
            text: `  ว.ด.ป .....${DATA.D_D} น. .....................ที่รับมอบ`,
            margin: [0, 0, 0, 0],
            pageBreak: "after",
          },

        ],
      },

      // ตช.5
      {
        columns: [{
            text: ``,
            width: 500,
            alignment: "center",
            // margin: [0, 0, 0, 0],//left top right bottom
          },
          {
            text: `ตช.5 `,
            width: 30,
            alignment: "right",
            // margin: [0, 0, 0, 10],//left top right bottom
            padding: [0, 0, 0, 10],
          },
        ],
      },
      {
        columns: [{
            text: `เลขที่ :   ${DATA.T_ID} \nวันที่พิมพ์    ${timeStemp} น. `,

            alignment: "left",
            // margin: [0, 0, 0, 0],//left top right bottom
          },
          {
            image: await getBase64ImageFromURL(
              conpany_name.LogoPath
            ),
            width: 60,
            // margin: [1, 15, 0, 0],
            alignment: "center",
          },
          {
            qr: DATA.rootURL,
            fit: 60,
            alignment: "right",
            margin: [0, 0, 0, 0], //left top right bottom
          },
        ],
      },
      {
        columns: [{
          text: `เอกสารกำกับขนส่งมูลฝอยติดเชื้อ ตช.5 ส่งองค์กรปกครองส่วนท้องถิ่นที่สถานที่กำจัดมูลฝอยติดเชื้อตั้งอยู่`,

          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 0],
        }, ],
        columnGap: 200,
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 80,
            text: `ชื่อเอกชน/ผู้เก็บขน ที่อยู่`,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: 500,
            text: "" + conpany_name.CoLtdMenuBarFull + " 389/40 หมู่ 2 ต.สันผีเสื้อ อ.เมือง จ.เชียงใหม่ 50300 เลขผู้เสียภาษีอากร 0505563001372 โทร 081-6949845",
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 80,
            text: `ลักษณะพาหนะที่ใช้`,
          },
          {
            table: {
              headerRows: 1,
              widths: [5],
              bodyRows: 2,
              body: [
                [{
                  text: " ",
                  fontSize: 5,
                }, ],
              ],
            },
            width: 19,
          },
          {
            // auto-sized columns have their widths based on their content
            width: 180,
            text: `1.ปรับอุณหภูมิ 10 ํC หรือต่ำกว่าได้`,
          },
          {
            table: {
              headerRows: 1,
              widths: [5],
              bodyRows: 2,
              body: [
                [{
                  text: " ",
                  fontSize: 5,
                }, ],
              ],
            },
            width: 19,
          },
          {
            // auto-sized columns have their widths based on their content
            text: `2. อื่นๆ ระบุ ....................................`,
          },
        ],
        // optional space between columns
      },
      {
        //ชื่อคนขับรถ
        columns: [{
            text: `เลขทะเบียนเก็บขนขยะ ${DATA.CAR_NUMBER} `,
            width: 130,
          },
          {
            text: ` ชื่อคนขับรถ ${DATA.PD_NAME} ${DATA.PD_LAST} `,
          },
          {
            text: ` ชื่อพนักงานเก็บขน ${DATA.PC_NAME} ${DATA.PC_LAST} `,
          },
          {
            text: ` เลขทะเบียนรถเปลี่ยนถ่าย .${DATA.CSI_CAR_N} `,
            width: 180,
          },
        ],
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 90,
            text: `คำรับรองของผู้ก่อนกำเนิด:`,

            bold: true,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: 500,
            text: "ข้าพเจ้าขอรับรองว่าได้ส่งมอบมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ คัดแยกประเภท บรรจุ ติดป้าย และฉลากอย่างเหมาะสมตามข้อกำหนดกฏหมาย",
          },
        ],
        // optional space between columns
      },
      {
        table: {
          headerRows: 1,
          widths: [45, 140, 40, 40, 60, 100, 40],
          bodyRows: 2,
          body: [
            [{
                text: "วันที่",
                bold: true,

                alignment: "center",
              },
              {
                text: "แหล่งกำเนิดมูลฝอยติดเชื้อ",
                bold: true,

                alignment: "center",
              },
              {
                text: "เวลาเข้าเก็บ",

                bold: true,
                alignment: "center",
              },
              {
                text: "เวลาออก",

                bold: true,
                alignment: "center",
              },
              {
                text: "ปริมาณมูลฝอย",

                bold: true,
                alignment: "center",
              },
              {
                text: "ขื่อ จนท.รพ",

                bold: true,
                alignment: "center",
              },
              {
                text: "ลายเซ็น",

                bold: true,
                alignment: "center",
              },
            ],
            [{
                text: `${newTimeDATAW_I.a}`,

                alignment: "center",
                justify: "center",
              },
              {
                text: DATA.C_N + " " + DATA.C_A,

                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_I} น.`,

                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_O} น.`,

                alignment: "center",
                justify: "center",
              },
              {
                text: DATA.W_W + " กก.",

                alignment: "center",
                justify: "center",
              },
              {
                text: ``, //DATA.P_N

                alignment: "center",
                justify: "center",
              },
              {
                image: await getBase64ImageFromURL(DATA.urlO),
                width: 35,
                height: 25,

                alignment: "center",
              },
            ],
          ],
        },
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 100,
            text: `คำรับรองของผู้ขนส่ง: `,

            bold: true,
            margin: [0, 3, 0, 0],
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: "*",
            text: "ข้าพเจ้าขอรับรองว่าได้รับมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ และได้ขนส่งไปตามข้อกำหนดของกฏหมาย",

            margin: [0, 3, 0, 0],
          },
        ],
        // optional space between columns
      },
      {
        //.................................................

        columns: [{
            text: `ชื่อตัวบรรจง   .................................................................................`,
            width: 205,
          },
          {
            text: `ลายเซ็น   .....................................`,
            width: 105,
          },
          {
            image: await getBase64ImageFromURL(
              conpany_name.SignaturePath
            ),
            width: 35,
            height: 20,
            margin: [0, 0, 0, 0],
          },
          {
            text: `......................................`,
            width: 165,
          },
        ],
      },
      {
        text: `________________________________________________________________________________________________________________________`,
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 50,
            text: `สถานที่กำจัด `,

            bold: true,
          },
          {
            // auto-sized columns have their widths based on their content

            text: `บริษัทโชติฐกรณ์พิบูล จำกัด ที่อยู่ 15/5 หมู่1 ต.หนองกรด อ.เมือง จ.นครสวรรค์ 60240 โทรศัพท์  090-9409932,086-4466295`,
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            // auto-sized columns have their widths based on their content
            width: 100,
            text: `คำรับรองของผู้กำจัด: `,

            bold: true,
          },
          {
            // star-sized columns fill the remaining space
            // if there's more than one star-column, available width is divided equally
            width: "*",
            text: "ข้าพเจ้าขอรับรองว่าได้รับมูลฝอยติดเชื้อตามที่ระบุข้างต้นนี้ ",
          },
          {
            text: `ปริมาณสุทธิ  ${DATA.W_W}  กิโลกรัม`,
            width: 100,
            alignment: "center",
          },
        ],
        // optional space between columns
      },
      {
        columns: [{
            text: `ชื่อตัวบรรจง     ..............................................................................`,
            width: 205,
          },
          {
            text: `ลายเซ็น ....`,
            width: 35,
          },
          {
            image: await getBase64ImageFromURL(DATA.urlR),
            width: 35,
            height: 20,
            alignment: "start",
          },
          {
            text: `.........`,
            width: 25,
          },
          {
            text: `  ว.ด.ป .....${DATA.D_D} น. .....................ที่รับมอบ`,
            margin: [0, 0, 0, 0],

          },

        ],
      },
    ],
    defaultStyle: {
      font: "THSarabunNew",
    },
    styles: {
      header: {
        fontSize: 18,
        alignment: "center",
        //bold: true
      },
      content: {
        fontSize: 14,
        alignment: "left",
        margin: [0, 0, 0, 0],
      },
      content_8: {
        fontSize: 16,
        alignment: "left",
        margin: [20, 10, 0, 0],
      },
      signature: {
        fontSize: 16,
        alignment: "center",
        margin: [0, 30, 0, 0],
      },
    },
  };
  return pdf;
};

function getBase64ImageFromURL(url) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = () => {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      var dataURL = canvas.toDataURL("image/png");

      resolve(dataURL);
    };

    img.onerror = (error) => {
      reject(error);
    };

    img.src = url;
  });
}
// The "callback" argument is called with either true or false
// // depending on whether the image at "url" exists or not.
// function imageExists(url, callback) {
//   var img = new Image();
//   img.onload = function() { callback(true); };
//   img.onerror = function() { callback(false); };
//   img.src = url;
// }

// // Sample usage
// var imageUrl = 'http://www.google.com/images/srpr/nav_logo14.png';
// imageExists(imageUrl, function(exists) {
//   console.log('RESULT: url=' + imageUrl + ', exists=' + exists);
// });

// create function TH time
async function newDates(data) {
  // console.log(data);
  let a = moment(data)
    .add(543, "years")
    .format("DD/MM/YYYY hh:mm:ss", true);
  return a;
}
async function newTime(data) {
  //console.log(data);
  let newTime = {
    a: "",
    b: ""
  };
  newTime.a = moment(data)
    .add(543, "years")
    .format("DD/MM/YYYY");
  newTime.b = moment(data).format("HH:mm", true);
  //console.log(newTime);
  return newTime;
}
async function newTimeN(data) {
  console.log(data);
  if (data != "-") {
    let a = moment(data)
      .add(543, "years")
      .format("DD/MM/YYYY HH:mm", true);
    return a;
  } else {
    return "-";
  }
}

export default print_document_a5;